import BaseCardBehavior from './BaseCardBehavior';
import CardStateHelper, { getCardsState } from '../CardStateHelper';
import { CardTask } from '../CardTasks';
import { CardType } from '../../../Prototype/Level/Card/CardType';
import { CardModifierType } from '../../../Prototype/Level/Card/CardModifierType';
import { SCORE_SCYTHE_CARD, SCORE_SCYTHE_TARGET_CARD } from '../../../Constants/Score';
import { IGameState } from '../../Game/IGameState';
import { initialCardStateData } from '../initialCardStateData';
import { CardState } from 'Prototype/Level/Card/CardState';
import CardStateModifierHelper from '../CardStateModifierHelper';

export default class ZapCardBehavior extends BaseCardBehavior {
    public play(state: IGameState): IGameState {
        const currentCardState = CardStateHelper.getCardState(state, this.cardID);

        const targets: string[] = [];

        if (currentCardState === CardState.IN_PLAY) {
            const zapCardData = CardStateHelper.getCardStateData(state, this.cardID);
            const offsetZap = zapCardData.offset ?? initialCardStateData.offset.clone();

            // Find all removable cards in play.
            // Regular, rising/lowering, fog, ice, bomb or pickaxe (value).
            const removableCardIDs = CardStateHelper.getCardsInPlay(state.levelState.cardsState, {
                requireCardTypes: [CardType.value],
            });

            removableCardIDs.forEach((cardID: string) => {
                const cardData = CardStateHelper.getCardStateData(state, cardID);
                const offsetCard = cardData.offset ?? initialCardStateData.offset.clone();

                if (cardData.type === CardType.gold) return;

                if (
                    Math.abs(zapCardData.x + offsetZap.x - cardData.x + offsetCard.x) < 2000 &&
                    Math.abs(zapCardData.y + offsetZap.y - cardData.y + offsetCard.y) < 100
                ) {
                    if (
                        !CardStateHelper.getCardBehavior(state.levelState.cardsState, cardID).isBlocked(
                            state.levelState.cardsState,
                            [CardModifierType.fog]
                        )
                    ) {
                        state = CardStateHelper.setCardDiscarded(state, cardID);

                        // Collect affected card IDs for task data.
                        targets.push(cardID);

                        const modifier = cardData.modifiers.find(m => m.type === CardModifierType.connected);
                        if (modifier) {
                            state = CardStateHelper.setCardDiscarded(state, modifier.properties.cardID);
                            targets.push(modifier.properties.cardID);
                        }
                    }
                }
            });
        }

        // Discard self.
        state = CardStateHelper.setCardDiscarded(state, this.cardID);

        // Add score.
        const scores: number[] = [SCORE_SCYTHE_CARD, ...Array(targets.length).fill(SCORE_SCYTHE_TARGET_CARD)];
        let cardsState = getCardsState(state);
        cardsState = CardStateHelper.addTurnScore(cardsState, ...scores);

        // Trigger zap animation task.
        cardsState = CardStateHelper.setStateTaskData(cardsState, {
            task: CardTask.ZAP,
            cards: [this.cardID, ...targets],
            cardsScore: [...scores],
        });

        // Update all cards behavior after some of them are discarded.
        state = CardStateHelper.updateGameState(state, cardsState);
        state = CardStateHelper.updateCards(state);
        state = CardStateModifierHelper.onCardPlayed(state, this.cardID);

        cardsState = getCardsState(state);

        // Clear undo history when a zap card is played.
        cardsState = CardStateHelper.clearUndoHistory(cardsState);

        return {
            ...state,
            levelState: {
                ...state.levelState,
                cardsState,
            },
        };
    }
}
